var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",attrs:{"id":"container"}},[_c('h4',{ref:"t",attrs:{"id":"title"}}),_c('div',{ref:"p",attrs:{"id":"plot"}})])}
var staticRenderFns = []

export { render, staticRenderFns }